import React from 'react';
import { styled } from '@linaria/react';

import { BREAKPOINTS } from '@/constants';

import MagicRainbowButton from './MagicRainbowButton';

const DemoButton = () => {
  return (
    <Wrapper>
      <WrappedButton id="demo-button">
        Magic Rainbow Button
      </WrappedButton>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 32px;
  margin-top: var(margin-bottom);
`;

const WrappedButton = styled(MagicRainbowButton)`
  width: 300px;
  height: 60px;
  font-size: 21px;
  border-radius: 5px;
  margin-left: 16px;

  @media ${BREAKPOINTS.sm} {
    margin-top: 16px;
    margin-left: 0;
    width: 100%;
  }
`;

export default DemoButton;
